export const FormModalStyles = {
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px 16px 32px 16px",
    gap: "10px",
    width: "359px",
  },
  blackXContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  blackXBox: {
    width: "31px",
    height: "31px",
    flexShrink: 0,
    cursor: "pointer",
    backgroundColor: "#E5E5E5",
    borderRadius: "50%",
    padding: "4px",
  },
  title: {
    fontFamily: "Roboto Condensed",
    color: "#000",
    fontSize: "28px",
    textAlign: "center",
    fontWeight: "700",
    lineHeight: "normal",
  },
  scriptContainer: {
    display: "flex",
    padding: "0px 16px",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "10px",
    alignSelf: "stretch",
  },
  script: {
    fontFamily: "Roboto Condensed",
    color: "#000",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  description: {
    fontFamily: "Roboto Condensed",
    color: "#000",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
  },
};
